/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { DialogDefaultV2 } from '../../../components/v2';

const ExpirarDialog = ({ open, onClose, onConfirm }) => (
  <DialogDefaultV2
    open={open}
    handlerCancel={onClose}
    handlerConfirm={onConfirm}
    title="Expirar Pedido de Voo"
    confirmMessage="Expirar"
    cancelMessage="Cancelar"
    maxWidth="sm"
    fullWidth
    useFullScreen={false}
  >
    <Typography variant="body2" color="text.secondary">
      Deseja marcar este pedido de voo como expirado?
    </Typography>
  </DialogDefaultV2>
);

ExpirarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ExpirarDialog;
